import React from "react";
import { Button } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const VideoPreview = ({ videoUrl, onDelete }) => {
  return (
    <div className="relative w-full rounded-xl overflow-hidden">
      <div className="aspect-video relative">
        <video
          src={videoUrl}
          className="w-full h-full"
          autoPlay
          muted
          loop
          playsInline
        />
        {onDelete && (
          <Button
            icon={<DeleteOutlined />}
            size="small"
            danger
            className="absolute top-2 right-2 !w-7 !h-7 !min-w-0 p-0 flex items-center justify-center"
            onClick={onDelete}
          />
        )}
      </div>
    </div>
  );
};

export default VideoPreview;
